export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14614.ec82fa7e.jpg";